import { Component, computed, input } from '@angular/core';
import C2U from '@chemist2u/types-client';
import { ImageComponent } from '../../primitives/image/image.component';

@Component({
    selector: 'app-profile-header',
    templateUrl: './profile-header.component.html',
    styleUrls: ['./profile-header.component.scss'],
    imports: [ImageComponent]
})
export class ProfileHeaderComponent {

  firstName = input.required<string>();
  lastName = input.required<string>();
  image = input<C2U.Interfaces.TSerializedParseFile>();

  url = computed(() => {
    return this.image() ? this.image()!._url : "assets/icons/profile-default.svg";
  });
}
